import { Component, OnInit } from '@angular/core';
import { AppService } from '@app/app.service';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { UserLevel } from '@app/core/models/user-level';
import { MenuService } from '@app/menu/services/menu.service';
import { RouterService } from '@app/routing/router.service';
import { reduceBooleans$ } from '@app/utils/rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-container',
  templateUrl: './portal-container.component.html',
  standalone: false,
})
export class PortalContainerComponent implements OnInit {
  portalContainer: boolean = true;
  readonly UserLevel = UserLevel;

  routerInitialized$: Observable<boolean> = this.routerService.currentRouteData$.pipe(
    take(1),
    map(() => true),
    shareReplay(1)
  );

  show$ = reduceBooleans$([
    this.authenticationService.isAuthenticated$,
    this.appService.initialized$,
    this.routerInitialized$,
  ]).pipe(untilDestroyed(this));

  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    private menuService: MenuService,
    private routerService: RouterService
  ) {}

  ngOnInit() {
    this.routerService.routeDataChange$.pipe(untilDestroyed(this)).subscribe((data) => {
      // this.logger.debug('portal-container route data changed', data)
      this.portalContainer = data.current.data?.hidePortalContainer !== true;
    });
  }

  public reload() {
    window.location.reload();
  }

  public toggleMobileSidebar() {
    if (document.body.classList.contains('nav-show')) {
      this.menuService.toggleSidebar(false);
    }
  }
}
